import { render, staticRenderFns } from "./DsVideoDetail.vue?vue&type=template&id=0384f0ba&scoped=true"
import script from "./DsVideoDetail.vue?vue&type=script&lang=js"
export * from "./DsVideoDetail.vue?vue&type=script&lang=js"
import style0 from "./DsVideoDetail.vue?vue&type=style&index=0&id=0384f0ba&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0384f0ba",
  null
  
)

export default component.exports